import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import FilterView from "../../common/filter";
import FormLabel from "controls/formLabel";
import { Form } from "react-bootstrap";
import type KiosksViewModel from "viewModels/administration/kiosks/kiosksViewModel";
import { translateGeneral } from "utils/localizations";
import AdvancedInput from "@edaz/edazkit/controls/AdvancedInput";

export interface KiosksFiltersProps {
  vm: KiosksViewModel;
}

const KiosksFilters = observer((props: KiosksFiltersProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <Form.Row>
        <Form.Group as={Col} lg={8} xl={6}>
          <FormLabel>{vm.translateFilterAttribute("name")}</FormLabel>
          <AdvancedInput target={vm.filter} property="name" placeholder={translateGeneral("search")} />
        </Form.Group>
      </Form.Row>
    </FilterView>
  );
});

export default KiosksFilters;
